import { withParse } from "@crm/effect/schema";
import { Schema } from "effect";

const studentIdSchema = Schema.String.pipe(
  Schema.check(
    Schema.makeFilter((studentId) => studentId.trim().length > 0, {
      message: "studentId 不能为空",
    }),
  ),
);

export const studentAccessInputSchema = withParse(Schema.Struct({ studentId: studentIdSchema }));

export type StudentAccessInput = Schema.Schema.Type<typeof studentAccessInputSchema>;
